/**
 * Documents & Photos section attached to the Service History form.
 *
 * Thin wrapper around `JobCardDocuments` — both views read/write the same
 * `/service-history-documents` collection, so anything uploaded here also
 * appears on the technician's JobCard service screen and on the SH detail
 * panel's Documents related list.
 *
 * Create mode: the row doesn't exist yet so there's nothing to attach
 * uploads to. Show a hint instead — the section becomes interactive once
 * the operator saves the record.
 */
import React from 'react';
import { JobCardDocuments } from './job-card-documents';
import type { FormExtrasContext } from '@/components/shared/crud-page';

export function ServiceHistoryDocumentsSubform({ isEdit, parentId }: FormExtrasContext) {
  return (
    <div className="border-t pt-4 mt-2 space-y-2">
      <h3 className="text-sm font-semibold uppercase tracking-wide text-muted-foreground border-b pb-2">
        Documents &amp; Photos
      </h3>
      {!isEdit || !parentId ? (
        <p className="text-xs text-muted-foreground py-2">
          Save the service record first — Documents &amp; Photos can be attached after the row exists.
        </p>
      ) : (
        <JobCardDocuments serviceHistoryId={parentId} />
      )}
    </div>
  );
}
